  <div class="counter-modal-container bg-white m-auto  flex flex-col items-center pb-3 w-60 lg:w-96">
    <button class="flex justify-center items-center bg-transparent ml-auto mt-2 mr-2" (click)="closeModal()">
      <ion-icon name="close" class="text-2xl leading-5 max-h-[24px] text-primary"></ion-icon>
    </button>
    <div class="flex flex-col lg:flex-row lg:gap-3">
      <div class="w-28 h-28">
        <img *ngIf="coinsCustomImage" [src]="coinsCustomImage" class="w-full h-full object-contain">
        <ng-lottie
        *ngIf="!coinsCustomImage"
        [options]="coinJumpOptions"
        width="100%"
        height="100%"
        ></ng-lottie>
      </div>
      <div class="flex flex-col items-center lg:items-start ">
        <p class="text-xs lg:text-sm font-bold">{{translations?.REWARD.MONEDAS }}</p>
        <p class="text-6xl leading-[4rem] font-bold">{{totalCoins}}</p>
        <p class="text-base">{{currencyName  | capitalize}}</p>
      </div>
    </div>
    <button class="bg-primary text-white rounded-lg py-3 px-6 my-4" (click)="goToBenefits()">
      {{translations?.REWARD.CANJEAR_MONEDAS }}
    </button>
    <button class="text-primary bg-transparent underline mb-4 hover:font-semibold " (click)="displayRewardsGuide()">
     {{translations?.REWARD.COMO_CONSEGUIR_MONEDAS }}
    </button>
    <button class="text-primary bg-transparent underline hover:font-semibold" (click)="goToCoinsTracking()">
      {{translations?.REWARD.MIS_MOVIMIENTOS }}
    </button>
  </div>
